import createConverter from './lib/create_converter';
import Customer from 'models/customer';

export default createConverter(Customer);



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/customer_converter.js